export const environment = {
    angular: {
        debugInfoEnabled: false
    },
    apiProxy: "__RASK:Core:Web:Config:ApiProxyUrl__",
    api: "__RASK:Core:Web:Config:ApiUrl__",
    apiV2: "__RASK:Core:Web:Config:ApiV2Url__",
    appInsights: {
        applicationRole: "RASK.Core.Web",
        autoTrackPageVisitTime: true,
        instrumentationKey: "__RASK:Core:Web:Config:AppInsights:InstrumentationKey__"
    },
    basemapLayers: {
        metriabakgrund: {
            baseMapLayers: [
                {

                    url: "__RASK:Core:Web:Config:MapServer4__/MetriaMapsBakgrund/MapServer"
                }
            ],
            thumbnailUrl: "https://js.arcgis.com/3.21/esri/images/basemap/topo.jpg",
            title: "Bakgrundskarta"
        },
        metriaorto: {
            baseMapLayers: [
                {

                    url: "__RASK:Core:Web:Config:MapServer4__/MetriaMapsOrto/MapServer"
                }
            ],
            thumbnailUrl: "https://js.arcgis.com/3.21/esri/images/basemap/satellite.jpg",
            title: "Ortofoto"
        }
    },
    dynamicFeatureLayers: [
        {
            id: "Collector",
            name: "Field Maps",
            opacity: 0.75,
            url: "__RASK:Core:Web:Config:MapServer2__/Rask/Faltplanering_virkeskop/MapServer",
            visible: true
        },
        {
            id: "Springfield",
            name: "Springfield",
            opacity: 0.75,
            url: "__RASK:Core:Web:Config:MapServer2__/Rask/Spring_Faltplanering_virkeskop/MapServer",
            visible: true
        },
        {
            id: "Arboreal",
            name: "Arboreal",
            opacity: 1,
            url: "__RASK:Core:Web:Config:MapServer2__/Faltplanering/Faltdata_collector/MapServer",
            visible: true
        },
        {
            id: "Virkeskop",
            name: "Virkesköp",
            opacity: 1,
            url: "__RASK:Core:Web:Config:MapServer2__/__RASK:Core:Web:Config:ArcGisServerFolderName__/Virkeskop/MapServer",
            visible: true
        },
        {
            id: "MetriaFastighetsgranser",
            name: "Metria Fastighetsgränser",
            opacity: 0.75,

            url: "__RASK:Core:Web:Config:MapServer4__/MetriaMapsFastighet/MapServer",
            visible: true
        },
        {
            id: "Naturhansyn",
            name: "Naturhänsyn",
            opacity: 0.75,
            url: "__RASK:Core:Web:Config:MapServer2__/__RASK:Core:Web:Config:ArcGisServerFolderName__/Naturhansyn/MapServer",
            visible: true
        },
        {
            id: "Restriktioner",
            name: "Restriktioner",
            opacity: 0.75,
            url: "__RASK:Core:Web:Config:MapServer2__/Verksamhet_Gem/GISSPRES_Restriktioner/MapServer",
            visible: true
        },
        {
            id: "AdministrativaGranser",
            name: "Administrativa gränser",
            opacity: 0.75,
            url: "__RASK:Core:Web:Config:MapServer2__/__RASK:Core:Web:Config:ArcGisServerFolderName__/Administrativa_granser/MapServer",
            visible: true
        },
        {
            id: "FornKulturminnen",
            name: "Forn- och kulturminnen",
            opacity: 0.75,
            url: "__RASK:Core:Web:Config:MapServer2__/Verksamhet_Gem/GISSPRES_Forn_o_kultur/MapServer",
            visible: true
        },
        {
            id: "Vagar",
            name: "Vägar",
            opacity: 0.75,
            url: "__RASK:Core:Web:Config:MapServer2__/__RASK:Core:Web:Config:ArcGisServerFolderName__/Vagar/MapServer",
            visible: true
        },
        {
            id: "Atgarder",
            name: "Åtgärder",
            opacity: 0.75,
            url: "__RASK:Core:Web:Config:MapServer2__/__RASK:Core:Web:Config:ArcGisServerFolderName__/Atgarder/MapServer",
            visible: true
        },
        {
            id: "Atgarder_selection",
            name: "Åtgärder (urval)",
            opacity: 1,
            url: "__RASK:Core:Web:Config:MapServer2__/__RASK:Core:Web:Config:ArcGisServerFolderName__/Atgarder_selection/MapServer",
            visible: true
        },
        {
            id: "Laserprodukter",
            name: "Laserprodukter",
            opacity: 0.75,
            url: "__RASK:Core:Web:Config:MapServer2__/Bakgrund_Gem/Laserprodukter/MapServer",
            visible: true
        },
        {
            id: "Allmanna_ytor_linjer_punkter",
            name: "Allmänna ytor linjer punkter",
            opacity: 0.75,
            url: "__RASK:Core:Web:Config:MapServer2__/__RASK:Core:Web:Config:ArcGisServerFolderName__/Allmanna_ytor_linjer_punkter/MapServer",
            visible: true
        },
        {
            id: "Egen_skog",
            name: "Egen skog",
            opacity: 0.75,
            url: "__RASK:Core:Web:Config:MapServer2__/__RASK:Core:Web:Config:ArcGisServerFolderName__/Egen_skog/MapServer",
            visible: true
        },
        {
            id: "Transportomraden",
            name: "Transportområden",
            opacity: 0.3,
            url: "__RASK:Core:Web:Config:MapServer2__/__RASK:Core:Web:Config:ArcGisServerFolderName__/Transport/MapServer",
            visible: true
        },
        {
            id: "Destineringsomraden",
            name: "Destineringsområden",
            opacity: 0.3,
            url: "__RASK:Core:Web:Config:MapServer2__/__RASK:Core:Web:Config:ArcGisServerFolderName__/Destineringsomrade/MapServer",
            visible: true
        },
        {
            id: "VerkGemAdminGrans",
            name: "Verksamhet Gem Administrativa gränser",
            opacity: 0.8,
            url: "__RASK:Core:Web:Config:MapServer2__/Verksamhet_Gem/Geografiskt_masterdata_Administrativa_granser_gallande/MapServer",
            visible: true
        },
        {
            id: "VerkGemLLD",
            name: "Verksamhet Gem LLD",
            opacity: 0.8,
            url: "__RASK:Core:Web:Config:MapServer2__/Verksamhet_Gem/GISSPRES_LLD/MapServer",
            visible: true
        },
        {
            id: "VerkGemLKF",
            name: "Verksamhet Gem LKF",
            opacity: 0.8,
            url: "__RASK:Core:Web:Config:MapServer2__/Verksamhet_Gem/GISSPRES_LKF/MapServer",
            visible: true
        },
        {
            id: "VerkGemFastigheter",
            name: "Verksamhet Gem Fastigheter",
            opacity: 0.8,
            url: "__RASK:Core:Web:Config:MapServer2__/Verksamhet_Gem/Fakta_Fastigheter/MapServer",
            visible: true
        },
        {
            id: "VerkGemSamfalligheter",
            name: "Verksamhet Gem Samfälligheter",
            opacity: 0.8,
            url: "__RASK:Core:Web:Config:MapServer2__/Verksamhet_Gem/Fakta_Samfalligheter/MapServer",
            visible: true
        },
        {
            id: "VerkGemVagar",
            name: "Verksamhet Gem Vägar",
            opacity: 0.8,
            url: "__RASK:Core:Web:Config:MapServer2__/Verksamhet_Gem/VFS_Vagar/MapServer",
            visible: true
        },
        {
            id: "VerkGemFaktaExternVindkraft",
            name: "Verksamhet Fakta Extern vindkraft",
            opacity: 0.8,
            url: "__RASK:Core:Web:Config:MapServer2__/Verksamhet_Gem/Fakta_ExternVindkraft/MapServer",
            visible: true
        },
        {
            id: "VerkGemFaktaBelastningar",
            name: "Verksamhet Fakta Belastningar",
            opacity: 0.8,
            url: "__RASK:Core:Web:Config:MapServer2__/Verksamhet_Gem/Fakta_Belastningar/MapServer",
            visible: true
        },

        {
            id: "Virkeskop_historiska",
            name: "Virkesköp historiska",
            opacity: 1,
            url: "__RASK:Core:Web:Config:MapServer2__/__RASK:Core:Web:Config:ArcGisServerFolderName__/Virkeskop/MapServer",
            visible: true
        },
        {
            id: "StinaKorstrak",
            name: "Körstråk",
            opacity: 1,
            url: "__RASK:Core:Web:Config:MapServer2__/Verksamhet_Gem/Stina_Korspar/MapServer",
            visible: true
        },
        {
            id: "StinaGrotpunkter",
            name: "Grotpunkter",
            opacity: 1,
            url: "__RASK:Core:Web:Config:MapServer2__/Verksamhet_Gem/Stina_Grot/MapServer",
            visible: true
        },
        {
            id: "StinaHansyn",
            name: "Hänsyn",
            opacity: 1,
            url: "__RASK:Core:Web:Config:MapServer2__/Verksamhet_Gem/Stina_Hansyn/MapServer",
            visible: true
        },
        {
            id: "StinaEgenritadeObjekt",
            name: "EgenritadeObjekt",
            opacity: 1,
            url: "__RASK:Core:Web:Config:MapServer2__/Verksamhet_Gem/Stina_Egenritade_objekt/MapServer",
            visible: true
        },
        {
            id: "smittad_zon_sjv",
            name: "smittad_zon_sjv",
            opacity: 0.75,
            url: "__RASK:Core:Web:Config:MapServer3__/Verksamhet_Gem/smittad_zon_sjv/MapServer",
            visible: true
        },
        {
            id: "Satellitbilder",
            name: "Satellitbilder",
            opacity: 1,
            url: "__RASK:Core:Web:Config:MapServer2__/Bakgrund_Gem/Satellitbilder/MapServer",
            visible: true
        },
        {
            id: "Drone",
            name: "Drone",
            opacity: 1,
            url: "__RASK:Core:Web:Config:MapServer2__/Bakgrund_Gem/Drone/MapServer",
            visible: true
        },
        {
            id: "VFS_PlaneradVag",
            name: "VFS_PlaneradVag",
            opacity: 1,
            url: "__RASK:Core:Web:Config:MapServer3__/Verksamhet_Gem/VFS_PlaneradVag/MapServer",
            visible: true
        },
        {
            id: "SKS_Avverkningsanmalningar",
            name: "Avverkningsanmälningar SKS",
            opacity: 1,
            url: "https://geodpags.skogsstyrelsen.se/arcgis/rest/services/Geodataportal/GeodataportalVisaAvverkningsanmalan/MapServer",
            visible: true
        },
        {
            id: "SKS_UtfordAvverkning",
            name: "Utförd avverkning SKS",
            opacity: 1,
            url: "https://geodpags.skogsstyrelsen.se/arcgis/rest/services/Geodataportal/GeodataportalVisaUtfordavverkning/MapServer",
            visible: true
        },
        {
            id: "RaskMottagningsplatser",
            name: "RaskMottagningsplatser",
            opacity: 1,
            url: "__RASK:Core:Web:Config:MapServer2__/Verksamhet_Gem/Rask_Mottagningsplatser/MapServer",
            visible: true
        },
        {
            id: "Renskotselomraden",
            name: "Renskötselområden",
            opacity: 1,
            url: "__RASK:Core:Web:Config:MapServer2__/Verksamhet_Gem/GISSPRES_Ren/MapServer",
            visible: true
        },
        {
            id: "Historto",
            name: "Historiska ortofoton",
            opacity: 1,
            url: "__RASK:Core:Web:Config:MapServer4__/historto?SERVICE=WMS&REQUEST=GetCapabilities&VERSION=1.3.0",
            visible: true,
            layerType: "wms"
        },
        {
            id:"Infrarodorto",
            name: "Infraröda ortofoton",
            opacity: 1,
            url: "__RASK:Core:Web:Config:MapServer4__/metriav2?SERVICE=WMS&REQUEST=GetCapabilities&VERSION=1.3.0",
            visible: true,
            layerType: "wms"
        }
    ],
    environment: "__RASK:Core:Web:Config:Environment__",
    geometryServer: "__RASK:Core:Web:Config:GeometryServer__",
    handsontableKey: "a5688-d5b4d-5d5f1-ca119-8a23d",
    mapProxy: "__RASK:Core:Web:Config:MapProxy__",
    arcgis4: {
        useProxyRules: true,
        proxyPrefixes: [
            "__RASK:Core:Web:Config:MapServer1__",
            "__RASK:Core:Web:Config:MapServer2__",
            "__RASK:Core:Web:Config:MapServer3__",
            "__RASK:Core:Web:Config:MapServer4__"
        ]
    },
    production: true,
    prologBaseUrl: "__RASK:Core:Web:Config:PrologBaseUrl__",
    prologGuiBaseUrl: "__RASK:Core:Web:Config:PrologGuiBaseUrl__",
    slutrapportUrl: "__RASK:Core:Web:Config:SlutrapportUrl__",
    svpPortalBaseUrl: "__RASK:Core:Web:Config:SvpPortalBaseUrl__",
    navetAppUrl: "__RASK:Core:Web:Config:NavetAppUrl__",
    maskinregisterUrl: "__RASK:Core:Web:Config:MaskinregisterUrl__",
    avverkningsanmalanWebbUrl: "__RASK:Core:Web:Config:AvverkningsanmalanWebbUrl__",
    releaseInfo: {
        buildNumber: "__RASK:Core:Web:Config:ReleaseInfo:BuildNumber__",
        publishDate: "__RASK:Core:Web:Config:ReleaseInfo:PublishDate__",
        releaseId: "__RASK:Core:Web:Config:ReleaseInfo:ReleaseId__"
    },
    eniroUrl: "https://www.eniro.se/{params}/personer",
    msalConfig: {
        auth: {
            clientId: "__RASK:Core:Web:Config:MsalConfig:Auth:ClientId__",
            authority: "https://login.microsoftonline.com/9defa683-0dca-4a4d-86f1-4e4d7759c8c3"
        }
    },
    apiConfig: {
        scopes: ["__RASK:Core:Web:Config:ApiConfig:Scopes__"]
    },
    powerBIConfig: {
        scopes: [
            "https://analysis.windows.net/powerbi/api/Report.Read.All",
            "https://analysis.windows.net/powerbi/api/Dataset.Read.All",
            "https://analysis.windows.net/powerbi/api/Workspace.Read.All"
        ],
        baseUrl: "https://api.powerbi.com/v1.0/myorg",
        hostname: "https://app.powerbi.com",
        rotstaendeLager: {
            webUrl: "https://app.powerbi.com/groups/me/apps/398a5269-db8c-4473-a1c8-f7c180118f49/reports/508ef2ae-3d3b-498e-aeab-979aa523f0ac",
            reportId: "8425cebb-c667-440b-a0bd-8370996e7edc",
            pageName: "edc91bd46e3adee5e200",
            visuals: {
                atgardstyp: "e119187b8c70a202d6a6",
                planeringsstatus: "bad3dbb0a75364e2b522"
            }
        },
        avrakningshjalpen: {
            webUrl: "https://app.powerbi.com/groups/me/apps/398a5269-db8c-4473-a1c8-f7c180118f49/reports/7b004557-4db7-41de-a40c-1617714c6d74",
            reportId: "df921ca2-6b4e-48f2-ac95-e334ba959bff",
            pageName: "b7f2d2a925b5c4e80343",
            visuals:{
                kontrakt: "3335fda71c00720c86d5"
            }
        }
    },
    uppdateraRaskEntraGrupper: "__RASK:Core:Web:Config:Common:UppdateraRaskEntraGrupper__",
    timestamp: "2026-11-04T11:11:50.918Z"
};
